<div class="happiness-meter" *ngIf="widgetVisible" [class.is-open]="isFabOpen">
	<div class="happiness-meter__panel" [style.display]="isFabOpen ? 'block' : 'none'">
		<div class="happiness-meter__panel-title">¿Cómo te sientes con nuestro servicio?</div>
		<div class="happiness-meter__ticks" role="group" aria-label="Selecciona cómo te sientes">
			<button
				type="button"
				class="happiness-meter__tick"
				*ngFor="let state of states"
				(click)="onTickClick(state.value)"
				(mouseenter)="onTickHover(state.value)"
				(mouseleave)="onTickLeave()"
				(focus)="onTickHover(state.value)"
				(blur)="onTickLeave()"
				[disabled]="disabledWidget"
				[ngClass]="[stateToneClass(state.value), selectedScore === state.value ? 'active' : '', hoveredScore === state.value ? 'is-hover' : '']"
				[attr.title]="state.label">
				<span class="happiness-meter__tick-emoji">{{ stateEmoji(state.value) }}</span>
			</button>
		</div>
		<div class="happiness-meter__label-row">
			<span class="happiness-meter__current" [ngClass]="[displayToneClass, hoveredScore !== null ? 'is-preview' : 'is-selected']">{{ displayStateLabel }}</span>
		</div>
	</div>

	<button type="button" class="happiness-meter__trigger" [disabled]="disabledWidget" (click)="toggleFab()" [attr.aria-expanded]="isFabOpen" title="¿Cómo te sientes?">
		<i class="fa-solid fa-face-smile-beam mr-2"></i>
		<span>¿Cómo te sientes?</span>
		<i class="fa-solid ml-2" [ngClass]="isFabOpen ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
	</button>
</div>

<ng-template #followupInviteModal>
	<div class="modal-header ux-feedback-modal__header ux-feedback-invite__header">
		<div class="ux-feedback-invite__title-wrap">
			<span class="ux-feedback-invite__badge">
				<i class="fa-regular fa-heart"></i>
			</span>
			<div>
				<h5 class="modal-title mb-1">Gracias por tu respuesta</h5>
				<p class="ux-feedback-modal__subtitle mb-0">¿Nos ayudas con 2–3 preguntas?</p>
			</div>
		</div>
	</div>
	<div class="modal-footer ux-feedback-modal__footer ux-feedback-invite__footer">
		<button type="button" class="btn btn-primary ux-feedback-btn" (click)="acceptInvite()">Responder</button>
		<button type="button" class="btn btn-outline-secondary ux-feedback-btn" (click)="declineInvite()">Ahora no</button>
	</div>
</ng-template>

<ng-template #followupQuestionModal>
	<div class="modal-header ux-feedback-modal__header">
		<div class="ux-feedback-survey__title-wrap">
			<span class="ux-feedback-survey__badge">
				<i class="fa-regular fa-comments"></i>
			</span>
			<div>
				<h5 class="modal-title mb-1">Mini encuesta</h5>
				<p class="ux-feedback-modal__subtitle mb-0">Nos tomará menos de 1 minuto.</p>
			</div>
		</div>
	</div>
	<div class="modal-body happiness-meter__followup-body ux-feedback-survey__body">
		<div class="happiness-meter__question ux-feedback-question-card" *ngFor="let question of followupQuestions">
			<p class="font-weight-bold mb-2 ux-feedback-question-card__title">
				{{ question.orderNo }}. {{ question.questionText }}
				<span class="text-danger" *ngIf="question.required">*</span>
			</p>

			<div *ngIf="question.questionType === 'single_choice'" class="happiness-meter__options">
				<div class="custom-control custom-radio custom-control-inline happiness-meter__option" *ngFor="let option of question.options">
					<input
						type="radio"
						class="custom-control-input"
						[id]="'single_' + question.questionKey + '_' + option.key"
						[name]="'single_' + question.questionKey"
						[checked]="singleAnswers[question.questionKey] === option.key"
						(change)="onSingleChoice(question.questionKey, option.key)" />
					<label class="custom-control-label" [for]="'single_' + question.questionKey + '_' + option.key">{{ option.text }}</label>
				</div>
			</div>

			<div *ngIf="question.questionType === 'multi_choice'" class="happiness-meter__options">
				<div class="custom-control custom-checkbox custom-control-inline happiness-meter__option" *ngFor="let option of question.options">
					<input
						type="checkbox"
						class="custom-control-input"
						[id]="'multi_' + question.questionKey + '_' + option.key"
						[checked]="isMultiSelected(question.questionKey, option.key)"
						(change)="onMultiChoice(question.questionKey, option.key, $any($event.target).checked)" />
					<label class="custom-control-label" [for]="'multi_' + question.questionKey + '_' + option.key">{{ option.text }}</label>
				</div>
			</div>

			<div *ngIf="question.questionType === 'text'">
				<textarea
					rows="2"
					class="form-control ux-feedback-textarea"
					maxlength="500"
					[value]="textAnswers[question.questionKey] || ''"
					(input)="onTextAnswerChanged(question.questionKey, $any($event.target).value)"></textarea>
				<div class="d-flex justify-content-between align-items-center mt-1">
					<small class="text-muted">No incluyas datos sensibles.</small>
					<small class="text-muted">{{ getTextLength(question.questionKey) }}/500</small>
				</div>
			</div>
		</div>

		<div *ngIf="formError" class="alert alert-warning py-2 mb-0 ux-feedback-form-error">
			{{ formError }}
		</div>
	</div>
	<div class="modal-footer ux-feedback-modal__footer">
		<button type="button" class="btn btn-outline-secondary ux-feedback-btn" (click)="cancelFollowup()" [disabled]="followupSending">Cancelar</button>
		<button type="button" class="btn btn-primary ux-feedback-btn" (click)="submitFollowup()" [disabled]="followupSending">
			{{ followupSending ? "Enviando..." : "Enviar respuestas" }}
		</button>
	</div>
</ng-template>
